import * as React from 'react';
import './TumourGroupsPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as TumourGroupActions from '../../../actions/tumourGroups';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';
interface ITumourGroupsPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  tumourGroup: Dtos.TumourGroup[];
  loadingTumourGroups: boolean;
  loadTumourGroupsSuccess: boolean;
  loadTumourGroupsFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface ITumourGroupsPageActions {
  clearTumourGroups: TumourGroupActions.ITumourGroupClearActionCreator;
  loadTumourGroups: TumourGroupActions.ITumourGroupLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: TumourGroupActions.ITumourGroupFilterActionCreator;
}
type TumourGroupsPageProps = ITumourGroupsPageProps & ITumourGroupsPageActions;
class TumourGroupsPage extends React.PureComponent<TumourGroupsPageProps, any> {
  constructor(props: TumourGroupsPageProps) {
    super(props);
    this.clearTumourGroups = this.clearTumourGroups.bind(this);
  }
  componentDidMount() {
    const {
      loadTumourGroups
    } = this.props;
    loadTumourGroups();
  }
  componentWillReceiveProps(nextProps: TumourGroupsPageProps) {}
  componentDidUpdate(prevProps: TumourGroupsPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: TumourGroupsPageProps) {}
  componentWillUnmount() {
    this.clearTumourGroups();
  }
  clearTumourGroups() {
    this.props.clearTumourGroups();
  }
  showTumourGroups(): boolean {
    const {
      loadingTumourGroups,
      loadTumourGroupsSuccess
    } = this.props;
    if (!loadingTumourGroups && loadTumourGroupsSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTumourGroups
    } = this.props;
    return <TrialLookupsLayout loading={loadingTumourGroups} permission={Dtos.Permission.TumorGroupsView} data-sentry-element="TrialLookupsLayout" data-sentry-component="TumourGroupsPage" data-sentry-source-file="TumourGroupsPage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Tumour Groups</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TumorGroupsCreate) && <Link className={"btn btn-primary"} url={"/settings/trial/tumourgroups/create"}>Create</Link>}
                </div>
            </div>
            {!this.showTumourGroups() ? "Loading Tumour Groups" : null}
            {this.showTumourGroups() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      tumourGroup
    } = this.props;
    if (!tumourGroup || tumourGroup.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no tumour groups to view.</span>
            </div>;
    }
    const showPagination = tumourGroup.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={tumourGroup} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : tumourGroup.length} pageSize={showPagination ? undefined : tumourGroup.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no tumourGroup to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/trial/tumourgroups/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TumourGroupsPageProps): ITumourGroupsPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.tumourGroups.formFilter,
    tumourGroup: state.tumourGroups.formFilteredData,
    loadingTumourGroups: state.tumourGroups.loadState && state.tumourGroups.loadState.status == RequestState.Pending,
    loadTumourGroupsSuccess: state.tumourGroups.loadState && state.tumourGroups.loadState.status == RequestState.Success,
    loadTumourGroupsFailure: state.tumourGroups.loadState && state.tumourGroups.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): ITumourGroupsPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadTumourGroups: bindActionCreators(TumourGroupActions.LoadTumourGroup, dispatch),
    clearTumourGroups: bindActionCreators(TumourGroupActions.Clear, dispatch),
    filter: bindActionCreators(TumourGroupActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TumourGroupsPage);